import Logger from '../lib/logger';
import redirect from '../lib/redirect';

/**
 * Thank You block (partials/blocks/thank-you.php).
 *
 * When the page is loaded with a ?redirect= param, the block renders it as
 * data-redirect, and we open it in a new tab after a short delay (falling
 * back to this tab if the browser blocks the new one). Without it, the page
 * stays put.
 */
const DELAY = 3000;

class ThankYou {
  constructor(dom) {
    this.NAME = 'ThankYou';
    this.dom = dom;
    this.redirect = dom.dataset.redirect;
  }

  init() {
    if (!this.redirect) return;

    Logger.info(`${this.NAME} > redirecting to ${this.redirect} in ${DELAY}ms`);
    setTimeout(() => redirect(this.redirect, '_blank'), DELAY);
  }
}

export default ThankYou;
